import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";

const RegistrosLogFilters = ({ onFilterChange, showFilter }) => {
  const [valuesFilters, setValuesFilters] = useState({});
  const { handleSubmit, reset } = useForm({});

  const handleClean = () => {
    reset({});
    setValuesFilters({});
  };

  const handleSearch = () => {
    onFilterChange(valuesFilters);
  };

  const handleChange = (e) => {
    setValuesFilters({
      ...valuesFilters,
      [e.target.name]: e.target.value
    });
    
  };

  return (
    <div className="filter-container">
      {showFilter ? (
        <div>
          <h3>Filtros</h3>
          <Form onSubmit={handleSubmit(handleSearch)}>
            <div>
              <Row className="mt-3">
                <Col className="col-dates col-auto" sm={12} md={6}>
                  <Form.Label className="label-date mb-2">Nombre:</Form.Label>
                  <Form.Control
                    name={"nombre"}
                    placeholder={"Nombre"}
                    onChange={handleChange}
                    style={{ width: 200 }}
                    value={valuesFilters?.nombre || ""}
                  />
                </Col>
                <Col className="col-dates col-auto" sm={12} md={6}>
                  <Form.Label className="label-date mb-2">Apellido</Form.Label>
                  <Form.Control
                    name={"apellido"}
                    placeholder={"Apellido"}
                    onChange={handleChange}
                    style={{ width: 200 }}
                    value={valuesFilters?.apellido || ""}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={6}>
                  <Form.Label className="label-date mb-2">DNI</Form.Label>
                  <Form.Control
                    name={"dni"}
                    placeholder={"DNI"}
                    onChange={handleChange}
                    style={{ width: 200 }}
                    value={valuesFilters?.dni || ""}
                  />
                </Col>
                {/* <Col className="col-auto" sm={12} md={6}>
                  <Form.Label className="mb-2">Orden Fecha</Form.Label>
                  <Controller
                    name="est_retiro"
                    control={control}
                    render={() => {
                      return (
                        <ReactSelect
                          options={tiposOrden}
                          onChange={(e) => setOrder(e)}
                          value={order.label ? order : ""}
                          styles={selectStyles}
                        />
                      );
                    }}
                  />
                </Col> */}
              </Row>
            </div>
          </Form>
          <Row className="d-flex justify-content-end">
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" />
                <span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                className="custom-button"
                onClick={handleSearch}
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default RegistrosLogFilters;